var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H42V42H6V6Z",
    fill: "#ECEFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 27.786L42 42V13.938L24 27.786Z",
    fill: "#CFD8DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 6H42L24 20.214L6 6H4.5C2.016 6 0 8.016 0 10.5V37.5C0 39.984 2.016 42 4.5 42H6V13.938L24 27.783L42 13.935V42H43.5C45.984 42 48 39.984 48 37.5V10.5C48 8.016 45.984 6 43.5 6Z",
    fill: "#F44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.44338aa22198d9a82bc635fe3117a364.svg";
export { ForwardRef as ReactComponent };